import { render, staticRenderFns } from "./InvitationsTable.vue?vue&type=template&id=25dbbe2d&scoped=true&"
import script from "./InvitationsTable.vue?vue&type=script&lang=js&"
export * from "./InvitationsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTable.vue?vue&type=style&index=0&id=25dbbe2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbbe2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
